var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGateway(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3840_86078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4875 1L6.86921 22.3571H0.00404119L9.68483 1H16.4875Z",
    fill: "url(#paint0_linear_3840_86078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9358 1L14.3175 22.3571H7.45233L17.1331 1H23.9358Z",
    fill: "#1B63CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3840_86078",
    x1: -10.2621,
    y1: 22.3568,
    x2: 18.1704,
    y2: 22.3568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B63CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00285631,
    stopColor: "#1B63CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DA2F2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3840_86078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21.5172,
    fill: "white",
    transform: "translate(0 1)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGateway);
export default __webpack_public_path__ + "static/media/gateway.90fbcd6b229f83fe4f898256f1be2111.svg";
export { ForwardRef as ReactComponent };